module.exports = __webpack_public_path__ + "img/es-cn.0ffbff27.svg";